import axiosInstance from "../services/axiosInstance";

export const getPackagesPrices = async () => {
    const response = await axiosInstance.get("/api/public/prices");
    return response.data;
};